import React from "react";
import { Eye, LogOut } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

// Shown when the platform owner is impersonating a company (set in localStorage
// by the "Log in as" action). Lets them exit back to the platform console.
export default function ImpersonationBanner() {
  const { user, logout } = useAuth();
  let imp = null;
  try { imp = JSON.parse(localStorage.getItem("impersonation") || "null"); } catch (_) { imp = null; }
  // Only show when the active session actually belongs to the impersonated user
  // (prevents a stale localStorage flag from showing on a normal login).
  if (!imp || !user || user === false || user.email !== imp.email) {
    if (imp && user && user !== false && user.email !== imp.email) {
      localStorage.removeItem("impersonation");
    }
    return null;
  }

  const exit = async () => {
    localStorage.removeItem("impersonation");
    await logout();
    window.location.href = "/platform/login";
  };

  return (
    <div data-testid="impersonation-banner" className="flex items-center gap-3 px-5 py-2 bg-cyan-600 text-white text-[13px]">
      <Eye className="h-4 w-4 shrink-0" />
      <span className="font-medium">Viewing <strong>{imp.companyName}</strong> as platform support.</span>
      <button data-testid="exit-impersonation-btn" onClick={exit}
        className="ml-auto inline-flex items-center gap-1.5 shrink-0 px-3 py-1 rounded-md bg-white text-cyan-700 text-[12px] font-semibold hover:bg-cyan-50">
        <LogOut className="h-3.5 w-3.5" /> Exit to console
      </button>
    </div>
  );
}
